// provides various methods required to alert certain parts of the system from anywhere,
// akin to context, but not the same.
const globalMenuHelper = {
    menuRefresher: undefined
};

export default globalMenuHelper;